import styles from "./User.module.css";
import { CircleUserRound, CircleCheckBig, CircleX, SquarePen } from "lucide-react";
import TagActive from "../TagActive";
import TagSubtitle from "../TagSubtitle";

function User({ thisUser, setIsOpenEdit, setIsOpenEditActive }) {
    const ativo = thisUser.emailConfirmed;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <div>
                        <CircleUserRound color="#f97015" />
                    </div>
                    <div>
                        <h3>{thisUser.name}</h3>
                        <TagSubtitle
                            text={thisUser.cargo}
                            color="#6a7181"
                            background="#f3f4f6"
                            padding="0.25rem 0.5rem"
                            fontSize="0.75rem"
                        />
                    </div>
                </div>
                <div>
                    {ativo ? <TagActive text="Ativo" icon={<CircleCheckBig size={12} color="hsl(142 71% 45%)" />} isActive={true} /> :
                        <TagActive text="Inativo" icon={<CircleX size={12} color="#6a7181" />} isActive={false} />}
                </div>
            </div>
            <div>
                <div className={styles.info1}>
                    <div className={styles.label}>
                        <span>ID</span>
                        <p>{thisUser.id}</p>
                    </div>
                    <div className={styles.label}>
                        <span>Setor</span>
                        <p>{thisUser.departamento}</p>
                    </div>
                    <div className={styles.label}>
                        <span>Email</span>
                        <p>{thisUser.userName}</p>
                    </div>
                </div>
                <div className={styles.divButton}>

                    {ativo ?
                        <button
                            onClick={() => {
                                setIsOpenEdit(thisUser);
                            }}
                        >
                            <SquarePen size={14} color="#1d212b" />
                            Editar
                        </button> : ""}
                    {ativo ?
                        <button
                            onClick={() => setIsOpenEditActive(thisUser)}
                        >
                            <CircleX size={14} color="#1d212b" />
                            Desativar
                        </button> 
                        :
                        <button
                            onClick={() => setIsOpenEditActive(thisUser)}
                        >
                            <CircleCheckBig size={14} color="#1d212b" />
                            Ativar
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}

export default User;